(function () {
  /**
   * Site-wide "you have a payment pending" banner for the deferred AlQaseh
   * checkout flow — parity with Flutter's PendingPaymentChromeStrip
   * (pendingCardPaymentBannerProvider), which the web theme lacked. Needed
   * now that eros-checkout.js/eros-checkout-payment-redirect.js defer
   * clearing the cart until payment is actually confirmed: without this, a
   * customer who navigates away mid-payment and returns would just see a
   * normal full cart with no context that a payment is already in flight.
   *
   * Storage is a single record (not a list, unlike
   * eros-cart-recently-removed.js) — only one card checkout can be pending
   * at a time. Saved/cleared by eros-checkout-payment-redirect.js's open()
   * and checkOnce(); this file only owns reading it and rendering the
   * banner. The 1-hour TTL mirrors commerce-worker's own
   * PENDING_CHECKOUT_TTL_SECONDS — server-side reconciliation (the
   * ten-minute cron) is always the actual authority; this is a client-side display
   * convenience only, never a source of truth.
   */

  var STORAGE_KEY = 'eros:checkout:pending-payment';
  var DISMISSED_KEY = 'eros:checkout:pending-payment:dismissed';
  var TTL_MS = 60 * 60 * 1000;

  var STR = (window.ErosAccountStrings && window.ErosAccountStrings.checkout) || {};
  function t(key, fallback) {
    return STR[key] || fallback;
  }

  function readRecord() {
    var raw;
    try {
      raw = localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
    if (!raw) return null;
    var record;
    try {
      record = JSON.parse(raw);
    } catch (e) {
      return null;
    }
    if (!record || !record.checkoutId || !record.paymentPageUrl || !record.startedAt) return null;
    if (Date.now() - record.startedAt >= TTL_MS) {
      clear();
      return null;
    }
    return record;
  }

  function save(checkoutId, paymentPageUrl) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ checkoutId: checkoutId, paymentPageUrl: paymentPageUrl, startedAt: Date.now() }),
      );
      sessionStorage.removeItem(DISMISSED_KEY);
    } catch (e) {}
    render();
  }

  function clear() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
    var el = document.getElementById('eros-pending-payment-banner');
    if (el) el.remove();
  }

  function isDismissed(checkoutId) {
    try {
      return sessionStorage.getItem(DISMISSED_KEY) === checkoutId;
    } catch (e) {
      return false;
    }
  }

  function render() {
    var existing = document.getElementById('eros-pending-payment-banner');
    if (existing) existing.remove();

    var record = readRecord();
    if (!record || isDismissed(record.checkoutId)) return;

    var bar = document.createElement('div');
    bar.id = 'eros-pending-payment-banner';
    bar.className = 'eros-pending-payment-banner';
    bar.setAttribute('role', 'status');

    var text = document.createElement('span');
    text.className = 'eros-pending-payment-banner__text';
    text.textContent = t('pending_payment_banner', 'لديك دفعة قيد الانتظار');
    bar.appendChild(text);

    var link = document.createElement('a');
    link.className = 'eros-pending-payment-banner__link';
    link.href = record.paymentPageUrl;
    link.target = '_blank';
    link.rel = 'noopener';
    link.textContent = t('payment_reopen', 'إعادة فتح صفحة الدفع');
    bar.appendChild(link);

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'eros-pending-payment-banner__close';
    closeBtn.setAttribute('aria-label', t('dismiss', 'إغلاق'));
    closeBtn.textContent = '×';
    closeBtn.addEventListener('click', function () {
      try {
        sessionStorage.setItem(DISMISSED_KEY, record.checkoutId);
      } catch (e) {}
      bar.remove();
    });
    bar.appendChild(closeBtn);

    document.body.insertBefore(bar, document.body.firstChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }

  // ADR-305: eros-checkout.js reads it to lock the confirm button while the payment is open.
  window.ErosPendingPaymentBanner = { save: save, clear: clear, current: readRecord };
})();
